import { render, staticRenderFns } from "./ClearResponsesConfirmationDialog.vue?vue&type=template&id=37a916e2"
import script from "./ClearResponsesConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ClearResponsesConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a916e2')) {
      api.createRecord('37a916e2', component.options)
    } else {
      api.reload('37a916e2', component.options)
    }
    module.hot.accept("./ClearResponsesConfirmationDialog.vue?vue&type=template&id=37a916e2", function () {
      api.rerender('37a916e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/ClearResponsesConfirmationDialog.vue"
export default component.exports